
export const PageNotFound = () => {
  return (
    <>
     <div className="p-6 bg-slate-300"></div>
    <div className='flex justify-center bg-black items-center mt-100 h-48 mb-10'>
        <h1 className='text-white'>Page Not Found</h1>
    </div>
    </>
  )
}
